import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';  
import ControllerTextArea from '../../SharedComponents/formComponents/baseFormComponents/ControllerTextArea';
import ControllerSelect from '../../SharedComponents/formComponents/baseFormComponents/ControllerSelect';
import ControllerTextInput from '../../SharedComponents/formComponents/baseFormComponents/ControllerTextInput';
import Arrow from '../assets/icons/Arrow';
import apiPublic from '../../../apiPublic';
import api from '../../../api';



const StepTwo = ({ data, onChange, onNext }) => {
  const { control, getValues } = useForm({
    defaultValues: {
      godina: data.godina || '',
      motor: data.motor || '',
      brojSasije: data.brojSasije || '',
      opis: data.opis || ''
    },
  });

  const [error, setError] = useState('');
  const [generations, setGenerations] = useState([]);
  const [motor, setMotor] = useState([{ value: '', label: 'Motor' }]);
  const [numVendors, setNumVendors] = useState(null);
    const [makes, setMakes] = useState(null);
    const [model, setModel] = useState(null);
  

  useEffect(() => {
    if (!data.model || !data.marka) return;

    const fetchGenerations = async () => {
      try {
        const response = await apiPublic.get(`/onboarding/modelgenerations/${data.model}`);
        setGenerations(response.data);
      } catch (err) {
        console.error('Greška pri učitavanju generacija:', err);
      }
    };
    fetchGenerations();
  }, [data.marka, data.model]);

  useEffect(() => {
    if (!data.godina) return;

    const fetchMotors = async () => {
      try {
        const response = await apiPublic.get(`/onboarding/generationmotor/${data.godina}`);
        setMotor(response.data);
      } catch (err) {
        console.error('Greška pri učitavanju motora:', err);
      }
    };
    fetchMotors();
  }, [data.godina]);

  useEffect(() => {
    if (!data.model || !data.marka) return;

    const fetchVendors = async () => {
      try {
        const response = await apiPublic.get(`/count-filters/${data.marka}/${data.model}`);
        setNumVendors(response.data);
      } catch (err) {
        console.error('Greška pri učitavanju broja prodavaca:', err);
      }
    };
    fetchVendors();
  }, [data.marka, data.model]);

useEffect(() => {
    if (data.marka) {
      const fetchMakes = async () => {
        try {
          const response = await apiPublic.get(`/onboarding/make/${data.marka}`);
          setMakes(response.data);
        } catch {
          console.error('Greška pri učitavanju marke.');
        }
      };
      fetchMakes();
    }
  }, [data.marka]);

  useEffect(() => {
    if (data.model) {
      const fetchModel = async () => {
        try {
          const response = await apiPublic.get(`/onboarding/model/${data.model}`);
          setModel(response.data);
        } catch {
          console.error('Greška pri učitavanju modela.');
        }
      };
      fetchModel();
    }
  }, [data.model]);


  const handleChangeField = (name, value) => {
    onChange({ target: { name, value } });
  };

  const handleNext = () => {
    const { godina, motor, brojSasije, opis } = getValues();

    if (!godina || !motor || !opis) {
      setError('Popunite sva obavezna polja!');
      return;
    }

    setError('');
    onNext({ godina, motor, brojSasije, opis });
  };

  return (
    <div style={styles.form}>
      <h2 style={styles.title}>
  {numVendors !== null && makes && model
    ? `${numVendors} prodavaca ima delove za ${makes.name} ${model.name}`
    : 'Učitavam broj prodavaca...'}
</h2>


      <div style={styles.topInputs}>
        <ControllerSelect
          name="godina"
          control={control}
          label="Godina - Generacija"
          options={generations}
          externalOnChange={(value) => {
            onChange({ target: { name: 'godina', value } });
          }}
          defaultValue={data.godina}
          width={250}
          placeholder="Godina - Generacija"
          styleForLabel={styles.selectStyle.styleForLabel}
          styleForSelect={styles.selectStyle.styleForSelect}
        />

        <ControllerSelect
          name="motor"
          control={control}
          label="Motor"
          options={motor}
          externalOnChange={(value) => {
            onChange({ target: { name: 'motor', value } });
          }}
          defaultValue={data.motor}
          width={250}
          placeholder="Motor"
          styleForLabel={styles.selectStyle.styleForLabel}
          styleForSelect={styles.selectStyle.styleForSelect}
        />

        <ControllerTextInput
          name="brojSasije"
          control={control}
          defaultValue={data.brojSasije}
          placeholder="Broj sasije (opciono, 17 karaktera)"
          onChange={(e) => handleChangeField(e.target.name, e.target.value)}
          width={180}
          styleForInput={{
            padding: '12px 16px',
            borderRadius: 6,
            border: '1px solid #787878',
            color: 'white',
            fontSize: '16px',
          }}
        />
      </div>

      <div style={styles.bottomInput}>
        <p style={styles.text}>
          Unesi detaljan opis dela koji tražiš da bi prikupio ponude
        </p>
        <ControllerTextArea
          name="opis"
          control={control}
          defaultValue={data.opis}
          placeholder="Na primer: 'Leva poluosovina...'"
          width={407}
          height={163}
          onChange={(e) => handleChangeField(e.target.name, e.target.value)}
          styleForTextArea={{
            borderColor: '#787878',
            fontSize: '14px',
            color: '#fff',
          }}
        />
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <button onClick={handleNext} style={styles.button}>
        Nastavi
        <Arrow />
      </button>
    </div>
  );
};

export default StepTwo;

const styles = {
  form: {
    maxWidth: 1000,
    margin: '0 auto',
    textAlign: 'center',
  },
  text: {
    color: 'rgba(255, 255, 255, 0.87)',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '28px',
    textAlign: 'center',
    marginBottom: 12, 
  },
  title: {
    fontSize: 22,
    marginBottom: 30,
  },
  topInputs: {
    display: 'flex',
    justifyContent: 'space-between',  
    gap: 16,
    marginBottom: 20,
    width: '100%',
  },
  bottomInput: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 16,
  },
  input: {
    padding: '12px 16px',
    borderRadius: 6,
    border: '1px solid #333',
    backgroundColor: '#1a1a1a',
    color: '#fff',
    fontSize: 16,
    minWidth: 180,
  },
  button: {
    padding: '12px 24px',
    backgroundColor: '#d3e205',
    color: '#0f0f0f',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    alignItems: 'center',
    fontSize:'20px',
    gap: 10,
  },
  error: {
    color: 'white',
    marginBottom: 12,
  },
  arrowIcon: {
    marginLeft: 8,
    width: 12,
    height: 16,
  },
  selectStyle: {
    styleForLabel: {
      color: 'white',
    },
    styleForSelect: {
      fontSize: '16px',
      border: '1px solid #787878',
      color: 'white', 
      '& .MuiSelect-icon': {
        color: 'white', 
      },
      '& .MuiMenuItem-root': {
        color: 'white', 
      },
    },
  },
};
